export default function Filter() {
	let newsFilters = document.querySelectorAll('.js-filters')
	let vacanciesFilters = document.querySelectorAll('.js-vacancies-filters')

	if (newsFilters.length) {
		newsFilters.forEach((filter) => {
			filter.addEventListener('change', () => {
				filter.closest('form').submit()
			})
		})
	}

	if (vacanciesFilters.length) {
		vacanciesFilters.forEach((filter) => {
			filter.addEventListener('change', (event) => {
				const urlParams = new URLSearchParams(window.location.search);
				
				if (urlParams.has('type') && filter.name === 'academy') {
					urlParams.delete('type');
				}
		
				if (filter.name === 'academy') {
					urlParams.set('academy', event.target.value);
				}
		
				if (filter.name === 'type') {
					urlParams.set('type', event.target.value);
				}

				if (filter.name === 'order') {
					urlParams.set('order', event.target.value);
				}
		
				window.location.search = urlParams.toString();
			})
		})
	}
}
